import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectInquiry = (state: RootState) => state.currentInquiry;

export const selectCurrentInquiry = createSelector(
  selectInquiry,
  (inquiriesState) => inquiriesState
);
